import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=570e860e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570e860e"]])

export default __exports__